import React from "react";
import { StyledExternalRewardWrapper } from "./policies.style";
import { useFormContext } from "react-hook-form";
import Field from "../../../../../formComponents/formFields/field.component";
import get from "lodash/get";

const Percentile = ({ options }) => {
  const {
    settings: { fields, pointsSharing },
  } = options;
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();
  const percentageWatch = watch("percentile_number");

  const text = pointsSharing
    .map((item) => {
      return `${(item.number * (percentageWatch || fields.percentile_number.value)).toFixed(2)}% share ${(item.reward_fraction * 100).toFixed(2)}% of the rewards pool`;
    })
    .join(", and the next ");

  return (
    <StyledExternalRewardWrapper>
      <div>
        <Field
          {...fields["percentile_number"]}
          register={register}
          error={get(errors, "percentile_number")}
        />
        % solvers will earn money
      </div>
      <div>{text}</div>
    </StyledExternalRewardWrapper>
  );
};

export default Percentile;
